/*
 *
 * RootModal constants
 *
 */
export const SET_MODAL                  = 'src/RootModal/SET_MODAL';
export const CLEAR_MODAL                = 'src/RootModal/CLEAR_MODAL';
export const INVALID_EMAIL              = 'src/RootModal/INVALID_EMAIL';
export const INVALID_PASSWORD           = 'src/RootModal/INVALID_PASSWORD';
export const PASSWORD_REQUIREMENTS      = 'src/RootModal/PASSWORD_REQUIREMENTS';
export const LOGIN_ERROR                = 'src/RootModal/LOGIN_ERROR';
export const LAPSED_MODAL               = 'src/RootModal/LAPSED_MODAL';
export const COLOR_PICKER               = 'src/RootModal/COLOR_PICKER';
export const PLAN_SELECTION             = 'src/RootModal/PLAN_SELECTION';
export const INTUITIVE_MODAL            = 'src/RootModal/INTUITIVE_MODAL';
export const TOS_SELECTION_MODAL        = 'src/RootModal/TOS_SELECTION_MODAL';
export const UPGRADE_TO_ENTERPRISE_MODAL= 'src/RootModal/UPGRADE_TO_ENTERPRISE_MODAL';
export const HAS_ALREADY_SIGNED_UP_MODAL= 'src/RootModal/HAS_ALREADY_SIGNED_UP_MODAL';
export const UNVERIFIED_EMAIL_MODAL     = 'src/RootModal/UNVERIFIED_EMAIL_MODAL';
export const VERIFICATION_RESENT_SUCCESS_MODAL = 'src/RootModal/VERIFICATION_RESENT_SUCCESS_MODAL';
export const VERIFICATION_RESENT_FAILURE_MODAL = 'src/RootModal/VERIFICATION_RESENT_FAILURE_MODAL';



// WEBPACK FOOTER //
// ./src/containers/RootModal/constants.js